// The admin pages' pill tab row (X83 Bookings, X99 Memberships & passes): components/admin/TlPillTabs.vue.

/** X85 (R31 N2): which ends of a sideways-scrolling tab row are cut off (2px slack for sub-pixel widths). */
export function tabsOverflow({scrollLeft = 0, scrollWidth = 0, clientWidth = 0} = {}) {
  if (scrollWidth <= clientWidth + 2) return {start: false, end: false};
  return {start: scrollLeft > 2, end: scrollLeft + clientWidth < scrollWidth - 2};
}

/** The width of the row's end fade with its chevron (TlPillTabs' mask: solid to 56px from the edge). */
export const TAB_FADE = 56;

/**
 * X113 (R49 L1): where a scrolling row must go so the active pill sits clear of the fade and chevron at either end,
 * not merely inside the row's bounds (at 390 the Settings pill was "in view" with its last letters under the arrow).
 * `row` {scrollLeft, scrollWidth, clientWidth}, `pill` {offsetLeft, offsetWidth}; null when no scroll is needed.
 * The margin is only asked for at an end that is cut off: the row's start and end have no fade.
 */
export function activeTabScroll(row, pill, margin = TAB_FADE) {
  const {scrollLeft = 0, scrollWidth = 0, clientWidth = 0} = row ?? {};
  if (!pill || scrollWidth <= clientWidth + 2) return null;
  const max = Math.max(0, scrollWidth - clientWidth);
  const left = pill.offsetLeft ?? 0;
  const right = left + (pill.offsetWidth ?? 0);
  const clearLeft = left - margin;          // the row's scrollLeft that puts the pill just clear of the start fade
  const clearRight = right + margin - clientWidth; // ... just clear of the end fade
  let to = scrollLeft;
  if (clearRight > scrollLeft) to = clearRight;
  if (clearLeft < to) to = clearLeft;
  to = Math.min(max, Math.max(0, Math.round(to)));
  return Math.abs(to - scrollLeft) > 1 ? to : null;
}

/** The tab the query names when the page has it, else the fallback (or the first). */
export function pickTab(tabs, query, fallback = null) {
  const wanted = query == null ? null : String(query);
  return tabs.find(t => t.value === wanted)?.value ?? (fallback && tabs.some(t => t.value === fallback) ? fallback : tabs[0]?.value ?? null);
}
